import { EnvVariable } from '../../enums';
import { getStringEnvVariable } from '../../utils';

const relativeUrl = (path: string, basePath = '/oauth/api/v1'): URL => {
  return new URL(basePath.concat(path), getStringEnvVariable(EnvVariable.SERVER_HOST));
};

export const OAuthApiUrls = {
  login(): URL {
    return relativeUrl('/login', '/server-resolver');
  },

  refreshToken(): URL {
    return relativeUrl('/token');
  },

  register(): URL {
    return relativeUrl('/activate_healthcare_organization_admin', '/server-resolver');
  },

  checkEmailInDatabase(): URL {
    return relativeUrl('/validate_healthcare_organization_admin_email', '/server-resolver');
  },

  forgotPassword(): URL {
    return relativeUrl('/forgotten_password', '/server-resolver');
  },

  fetchAccount(): URL {
    return relativeUrl('/account');
  },

  logout(): URL {
    return relativeUrl('/account/logout');
  },
};
